module.exports = __webpack_public_path__ + "static/img/jianzhu05.d0d2583.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/jianzhu05.png
// module id = zpEV
// module chunks = 12